module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-area-warp"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "fl",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', [_vm._v("选择地址")]), _vm._v(" "), _c('div', {
    staticClass: "fr",
    class: {
      'available': _vm.pedding
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "select-area"
  }, [_c('div', {
    staticClass: "indicator"
  }), _vm._v(" "), _c('item', {
    attrs: {
      "list": _vm.province,
      "column": 0,
      "show": _vm.show
    },
    on: {
      "on-change": _vm.change
    }
  }), _vm._v(" "), _c('item', {
    attrs: {
      "list": _vm.city,
      "column": 1,
      "show": _vm.show
    },
    on: {
      "on-change": _vm.change
    }
  }), _vm._v(" "), _c('item', {
    attrs: {
      "list": _vm.district,
      "column": 2,
      "show": _vm.show
    },
    on: {
      "on-change": _vm.change
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cda41df"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/select-area/index.vue
// module id = 267
// module chunks = 2 3 4 7 8 11 12 18 65 67